import API from '../api';
import MeetingRoomView from '../models/view/MeetingRoomView';
import repositoryHelper from '../helpers/RepositoryHelper';
import OccupiedMeetingRoomView from '../models/view/OccupiedMeetingRoomView.js';
import MeetingRoomFilterView from '../models/view/MeetingRoomFilterView';

export default () => ({
    add(meetingRoom, authorizationGroups) {
        const formData = Object.assign({}, meetingRoom, {authorizationGroups});

        return API.postJSON('/api/admin/meeting-room/create', formData)
            .then(API.handle)
            .catch(API.error)
            .then(raw => new MeetingRoomView(raw));
    },
    addMultiple(meetingRooms) {
        if (meetingRooms.length === 0) {
            return Promise.resolve({created: [], errors: []});
        }

        const roomId = meetingRooms[0].room;
        const resources = meetingRooms.map(item => ({
            resourceTypeId: '775176b8-23d2-44d2-ae11-4b58e384a2dd', // ResourceType::GLOBAL_MEETING_ROOM
            name: item.name || null,
            locationX: item.locationX,
            locationY: item.locationY,
            characteristics: item.characteristics || [],
            blocked: item.blocked || false,
            calendarResourceId: item.calendarResourceId || null,
            authorizationGroups: item.authorizationGroups || null,
        }));

        return API.postJSON(`/api/admin/resource/createMultiple/${roomId}`, {resources})
            .then(API.handle)
            .catch(API.error);
    },

    browseAdmin(roomId) {
        return API.get(`/api/admin/meeting-room/${roomId}/all`)
            .then(API.handle)
            .catch(API.error)
            .then(raw => raw.map(singleRaw => new MeetingRoomView(singleRaw)));
    },

    getNextAvailableMeetingRoomName(roomId) {
        return API.get(`/api/admin/meeting-room/${roomId}/nextAvailableName`)
            .then(API.handle)
            .catch(API.error);
    },

    filter(location, room, characteristics, days, timeframe, from, until) {
        const url = repositoryHelper.methods.createFilterUrl(
            '/api/meeting-room/filter',
            location,
            room,
            characteristics,
            days,
            timeframe,
            from,
            until
        );

        return API.get(url)
            .then(API.handle)
            .catch(API.error)
            .then(raw => new MeetingRoomFilterView(raw));
    },
    filterOccupied(location, room, characteristics, days, timeframe, from, until) {
        const url = repositoryHelper.methods.createFilterUrl(
            '/api/meeting-room/filter/occupied',
            location,
            room,
            characteristics,
            days,
            timeframe,
            from,
            until
        );

        return API.get(url)
            .then(API.handle)
            .catch(API.error)
            .then(raw => raw.map(singleRaw => new OccupiedMeetingRoomView(singleRaw)));
    },
    details(meetingRoomId) {
        return API.get(`/api/meeting-room/${meetingRoomId}`)
            .then(API.handle)
            .catch(API.error)
            .then(json => new MeetingRoomView(json));
    },

    detailsAdmin(meetingRoomId) {
        return API.get(`/api/admin/meeting-room/${meetingRoomId}`)
            .then(API.handle)
            .catch(API.error)
            .then(json => new MeetingRoomView(json));
    },

    edit(meetingRoom, authorizationGroups) {
        const formData = Object.assign({}, meetingRoom, {authorizationGroups});

        return API.postJSON(`/api/admin/meeting-room/${meetingRoom.id}/edit`, formData)
            .then(API.handle)
            .catch(API.error);
    },

    delete(meetingRoom) {
        return API.delete(`/api/admin/meeting-room/${meetingRoom.id}`)
            .then(API.handle)
            .catch(API.error);
    },
});
